
<template>
  <div>
    <movement-create class="mb-4" @done="handleDoneNewMovement"></movement-create>

    <base-card :with_title="false" :with_actions="false">
    <template slot="content">
        <!-- {{ other_data }} -->
        <v-row v-if="other_data && other_data.sums" aling="center" justify='center' class="py-2 mb-1">
          <v-col cols="12" sm="4" v-for="(sum, key) in other_data.sums" :key="key" align='center'>
            <div class="subtitle-1">
              {{ $t(`financials.${key}`) }} total
            </div>
            <div :class="['subtitle-1 font-weight-bold', key == 'income'? 'primary--text' : 'error--text']">
              {{ (Number(sum)/100).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
            </div>
          </v-col>
          <v-col cols="12" sm="4" align='center'>
            <div class="subtitle-1">
              Saldo
            </div>
            <div :class="['subtitle-1 font-weight-bold',other_data.sums.income > other_data.sums.outcome ? 'primary--text' : 'error--text' ]">
              {{ (Number((other_data.sums.income - other_data.sums.outcome))/100).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
            </div>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="movements"
          class="elevation-0"
          :loading="loading_data"
          :options.sync="options"
          :server-items-length="total_data"
          :footer-props="{itemsPerPageOptions: [15,25,50]}"
          mobile-breakpoint="1"
          ref='table'
          mobile_breakpoint="1"
        >
          <template v-slot:header.name="{ header }">
            <span>
              {{ header.text }}
              <sort-filter-table :header="header" @sentFilter="handleSentFilter"></sort-filter-table>
            </span>
          </template>
          <template v-slot:header.status="{ header }">
            <span>
              {{ header.text }}
              <sort-filter-table :header="header" :use_search="false" 
                :options="status_options" use_options use_multiple operator="_in"
                @sentFilter="handleSentFilter"
              ></sort-filter-table>
            </span>
          </template>
          <template v-slot:header.kind="{ header }">
            <span>
              {{ header.text }}
              <sort-filter-table :header="header" :use_search="false" 
                :options="kind_options" use_options use_multiple operator="_in"
                @sentFilter="handleSentFilter"
              ></sort-filter-table>
            </span>
          </template>
          <template v-slot:header.due_date="{ header }">
            <span>
              {{ header.text }}
              <sort-filter-table :header="header" :use_search="false" use_date
                @sentFilter="handleSentFilter"
              ></sort-filter-table>
            </span>
          </template>


          <template v-slot:item.value="{item}">
            <span :class="item.kind == 'income'? 'primary--text' : 'error--text'">
              {{ (Number(item.value)/100).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
            </span>
          </template>
          <template v-slot:item.due_date="{item}">
            {{ $dayjs(item.due_date).format('DD/MM/YYYY') }}
          </template>
          <template v-slot:item.kind="{item}">
            {{ $t(`financials.kinds.${item.kind}`) }}
          </template>
          <template v-slot:item.status="{item}">
            {{ $t(`financials.statuses.${item.status}`) }}
          </template>
          <template v-slot:item.actions="{item}">
            <v-btn icon small color="grey darken-2" @click="showMovement(item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon small color="grey darken-2" @click="deleteMovement(item)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>

      </template>
      <template></template>
    
    </base-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
import TablePagination from '@/mixins/table_pagination.js';
import Api from '@/api/index';
import MovementCreate from './MovementCreate.vue';

export default {
  name: 'MovementList',
  components: {
    MovementCreate
    //ComponentName: () => import(''),
  },
  mixins: [
    TablePagination
  ],
  data() {
    return {
      loading: false,
      movements: [],
      headers: [
        {text: this.$tc('financials.description_form_label', 2), value: 'name', sortable: false},
        {text: this.$tc('financials.value_form_label', 2), value: 'value', sortable: false},
        {text: this.$t('financials.due_form_label'), value: 'due_date', sortable: false},
        {text: this.$t('financials.kind_form_label'), value: 'kind', sortable: false},
        {text: this.$t('financials.status_form_label'), value: 'status', sortable: false},
        {text: this.$t('action'), value: 'actions', sortable: false},
      ],

      local_filter: {},

      status_options: [
        {text: this.$t('financials.statuses.open'), value: '1'},
        {text: this.$t('financials.statuses.payed'), value: '10'},
        {text: this.$t('financials.statuses.overdue'), value: '20'},
        {text: this.$t('financials.statuses.canceled'), value: '30'},
      ],
      kind_options: [
        {text: this.$t('financials.kinds.income'), value: '1'},
        {text: this.$t('financials.kinds.outcome'), value: '10'},
      ],

    }
  },
  methods: {
    handleSentFilter(e){
      // if (this.user.kind == 'supplier') {
      //   this.local_filter = {...this.local_filter, supplier_id: this.user.dept_ids[0]}
      // }

      let {sorts, searches, ...rest} = this.local_filter
      sorts = sorts || [] 
      searches = searches || [] 

      this.local_filter = {
        ...rest,
        ...e,
        // sorts: [...new Set([...sorts, ...e.sorts])],
        searches: {...searches, ...e.searches},
        sorts: {...sorts, ...e.sorts},
      }
      if (!Object.values(e.searches)[0]){
        delete this.local_filter.searches[Object.keys(e.searches)[0]]
      }
      if (!Object.values(e.searches)[1]){
        delete this.local_filter.searches[Object.keys(e.searches)[1]]
      }
      if (!Object.values(e.sorts)[0]){
        delete this.local_filter.sorts[Object.keys(e.sorts)[0]]
      }

      this.getMovements()
    },
    getMovements(){
      this.options.page = 1;
      this.default_source_kind = 'local'

      this.getDataFromApi(
        'Movement',
        'index',
        'movements',
        'data',
        'total',
        {
          ...this.local_filter
        }
      )
    },
    deleteMovement(item){
      this.loading = true
      Api.Movement.delete(item.id).then(r=>r.data).then(d=> {
        this.getMovements()
      }).catch(err=> {
        console.log({err});
      }).finally(()=>{
        this.loading = false
      })
    },
    showMovement(item){
      this.$router.push({name: 'ShowMovement', params: {id: item.id}})
    },
    handleDoneNewMovement(e){
      this.getMovements()
    },

    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.getMovements();
  },
  watch: {
    '$route'(nv,ov) {
      // console.log({ov, nv});
      if (['ShowMovement'].includes(ov.name)){
        this.getMovements()
      }
    }
  },
}
</script>

<style scoped>

</style>